<template>
  <div class="h-screen w-full form-container px-4 pt-16">
    <div class="bg-white shadow sm:rounded-lg max-w-xl m-auto mt-10">
      <component v-if="$route.params.formname" :is="formComponent" />
    </div>
  </div>
</template>
<script>
import { defineAsyncComponent } from '@vue/runtime-core'

export default {
  computed: {
    formComponent() {
      return defineAsyncComponent(
        () => import(`@/forms/${this.$route.params.formname}`)
      )
    }
  }
}
</script>
<style>
.form-container {
  background-color: #f2f4f6;
}
</style>